import { addToDebugData } from '@wix/package-picker-shared';
import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import { UpgradeApiClientContext } from '../upgrade.context';
export const getCurrentProductQueryFn = async _ref => {
  let {
    httpClient
  } = _ref;
  const {
    getPurchaseUserOffering
  } = PremiumPurchasePlatformModule.SDK.ApiClient.queries({
    httpClient
  });
  const p3Context = UpgradeApiClientContext.get('p3Context');
  if (!p3Context) {
    throw new Error('P3 context is required to get current product');
  }
  const getPurchaseUserOfferingResponse = await getPurchaseUserOffering({
    ...p3Context
  });
  const {
    currentSubscriptionInfo,
    products
  } = getPurchaseUserOfferingResponse;
  addToDebugData({
    currentSubscriptionInfo
  });
  const isCurrentProductFamilyInOffering = products == null ? void 0 : products.some(product => product.productFamilyId === (currentSubscriptionInfo == null ? void 0 : currentSubscriptionInfo.productFamilyId));
  const isCurrentProductInOffering = products == null ? void 0 : products.some(product => product.productId === (currentSubscriptionInfo == null ? void 0 : currentSubscriptionInfo.productId));
  return {
    currentProduct: currentSubscriptionInfo,
    isCurrentProductFamilyInOffering,
    isCurrentProductInOffering
  };
};
//# sourceMappingURL=getCurrentProduct.js.map